import { render } from "./PixKeyDetails.vue?vue&type=template&id=84cb379e"
import script from "./PixKeyDetails.vue?vue&type=script&lang=js"
export * from "./PixKeyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__